<lx-price-lists-portal-price-list-panel
  [priceListFilters]="filters$ | async"
  [withData]="(ayaSchoolTables$ | async)?.length > 0"
  (filtersChanged)="filterAyaSchools($event)"
>
  <lx-price-lists-portal-aya-data [ayaSchoolTables$]="ayaSchoolTables$"></lx-price-lists-portal-aya-data>
</lx-price-lists-portal-price-list-panel>
